import { Dataset } from '~/packages/general/system/bulk/systemBulk.data'
import {
  parseCsvLocalDateTime,
  parseBooleanValue,
  parseEnumEmptyString,
} from '~/prix/utils/bulk/csvValueParsers'

const homeVisit: Dataset = {
  schema: 'public_health',
  table: 'home_visit',
  columnTransformMap: {
    original_id: original => original,
    data_source_id: original => original,
    citizen_cpf: original => original,
    citizen_cns: original => original,
    visit_date: original => parseCsvLocalDateTime(original as string),
    shift: original => parseEnumEmptyString(original as string),
    professional_cns: original => original,
    professional_cbo: original => original,
    professional_cnes: original => original,
    professional_ine: original => original,
    visit_reason_is_registration_update: original => parseBooleanValue(original as string),
    visit_reason_is_periodic_visit: original => parseBooleanValue(original as string),
    visit_reason_is_active_search_for_consultation: original =>
      parseBooleanValue(original as string),
    visit_reason_is_active_search_for_examination: original =>
      parseBooleanValue(original as string),
    visit_reason_is_active_search_for_vaccination: original =>
      parseBooleanValue(original as string),
    visit_reason_is_active_search_for_bolsa_familia_conditionalities: original =>
      parseBooleanValue(original as string),
    visit_reason_is_pregnant_woman_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_postpartum_woman_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_newborn_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_child_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_malnutrition_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_rehabilitation_or_person_with_disability_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_hypertension_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_diabetes_person_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_asthma_person_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_copd_emphysema_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_cancer_patient_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_other_chronic_diseases_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_person_with_leprosy_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_person_with_tuberculosis_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_respiratory_symptomatic_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_smoker_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_homebound_bedridden_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_social_vulnerability_conditions_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_bolsa_familia_conditionalities_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_mental_health_person_follow_up: original =>
      parseBooleanValue(original as string),
    visit_reason_is_alcohol_user_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_other_drugs_user_follow_up: original => parseBooleanValue(original as string),
    visit_reason_is_discharge_from_hospitalization: original =>
      parseBooleanValue(original as string),
    visit_reason_is_environmental_vector_control: original => parseBooleanValue(original as string),
    visit_reason_is_invitation_to_collective_activities_health_campaign: original =>
      parseBooleanValue(original as string),
    visit_reason_is_guidance_prevention: original => parseBooleanValue(original as string),
    visit_reason_is_other: original => parseBooleanValue(original as string),
    outcome_status: original => parseEnumEmptyString(original as string),
    created_at: original => parseCsvLocalDateTime(original as string),
    updated_at: original => parseCsvLocalDateTime(original as string),
  },
}

export default homeVisit
